import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { IMaskModule } from 'angular-imask';
import { InvalidFieldComponent } from '../../components';
import { HandlerBackAndBreadcrumbButtonComponent } from '../../components/handler-back-and-breadcrumb-button/handler-back-and-breadcrumb-button.component';
import { MatStrokedButtonBorderDirective } from '../../directives';
import { NominationMaterialModule } from './nomination-material.module';
import { NominationComponent } from './nomination.component';

@NgModule({
    imports: [
        CommonModule,
        NominationMaterialModule,
        HandlerBackAndBreadcrumbButtonComponent,
        FormsModule,
        ReactiveFormsModule,
        InvalidFieldComponent,
        NgSelectModule,
        MatStrokedButtonBorderDirective,
        IMaskModule,
    ],
    declarations: [NominationComponent],
    exports: [NominationComponent],
})
export class NominationModule {}
